import config from '../config'

var departmentCollectionCache
var cityCollectionCache = {}

class AdministrativeDivisionError extends Error {

    constructor(message, statusCode) {
        super(message)
        this.stack = (new Error()).stack
        this.name = 'AdministrativeDivisionError'
        this.message = message
        this.statusCode = statusCode
    }
}

function loadDepartmentCollection() {
    if (departmentCollectionCache) {
        return departmentCollectionCache
    }

    if (!config.administrativeDivision.api.url || config.administrativeDivision.api.url == 'unset') {
        return departmentCollectionCache = Promise.reject(new AdministrativeDivisionError(400, 'API url not set'))
    }

    return departmentCollectionCache = fetch(config.administrativeDivision.api.url + '/france/department/').then((response) => {
        if (response.status >= 200 && response.status < 300) {
            return response.json()    
        }
        
        const statusText = response.statusText
        const statusCode = response.status
        throw new AdministrativeDivisionError(statusText, statusCode)
    })
}

function loadCityCollection(departmentCode) {
    if (cityCollectionCache[departmentCode]) {
        return cityCollectionCache[departmentCode]
    }

    if (!config.administrativeDivision.api.url || config.administrativeDivision.api.url == 'unset') {
        return cityCollectionCache[departmentCode] = Promise.reject(new AdministrativeDivisionError(400, 'API url not set'))
    }

    return cityCollectionCache[departmentCode] = fetch(config.administrativeDivision.api.url + '/france/department/' + departmentCode + '/city/').then((response) => {
        if (response.status >= 200 && response.status < 300) {
            return response.json()    
        }
        
        const statusText = response.statusText
        const statusCode = response.status
        throw new AdministrativeDivisionError(statusText, statusCode)
    })
}

export function getAdministrativeDivision({division, code, departmentCode}) {
    if (division == 'department') {
        return loadDepartmentCollection().then((collection) => {
            const feature = collection.features.find((f) => f.properties.code == code)

            if (!feature) {
                console && console.warn('department ' + code + ' doesn\'t exist in administrative data set')
            }
            return feature
        })
    }

    if (division == 'city') {
        return loadCityCollection(departmentCode).then((collection) => {
            const feature = collection.features.find((f) => f.properties.code == code)

            if (!feature) {
                console && console.warn('city ' + code + ' doesn\'t exist in department ' + departmentCode + ' data set')
            }
            return feature
        })
    }
}




// WEBPACK FOOTER //
// ./lib/core/administrativeDivision.js